function MidasResponse(validated, errorNumber, errorDescription, actionCode, jwe, paymentObject, consumerObject, tokenObject, authorizationProcessorObject, authorizationObject, riskObject) {
  this.Validated = validated || false;
  this.ErrorNumber = errorNumber;
  this.ErrorDescription = errorDescription || "";
  this.ActionCode = actionCode || "ERROR";
  
  if(paymentObject){
    this.Payment = paymentObject;
  }
  if(consumerObject){
    this.Consumer = consumerObject;
  }
  if(tokenObject){
    this.Token = tokenObject;
  }
  if(authorizationProcessorObject){
    this.AuthorizationProcessor = authorizationProcessorObject;
  }
  if(authorizationObject){
    this.Authorization = authorizationObject;
  }
  if(riskObject){
    this.Risk = riskObject;
  }
  if(jwe){
    this.JWE = jwe;
  }
}

module.exports = MidasResponse;



//////////////////
// WEBPACK FOOTER
// ./models/midasResponse.js
// module id = 45
// module chunks = 0 5 20